import React, { useState } from 'react';
import styles from './Project.module.css';
import firstP1 from "../../images/שיפוץ ועיצוב דירה קטנה ומטריפה 1.webp";
import firstP2 from "../../images/שיפוץ ועיצוב דירה קטנה ומטריפה 2.webp";
import firstP3 from "../../images/שיפוץ ועיצוב דירה קטנה ומטריפה 3.webp";
import firstP4 from "../../images/שיפוץ ועיצוב דירה קטנה ומטריפה 4.webp";
import firstP5 from "../../images/שיפוץ ועיצוב דירה קטנה ומטריפה 5.webp";
import firstP6 from "../../images/שיפוץ ועיצוב דירה קטנה ומטריפה 6.webp";
import firstP7 from "../../images/שיפוץ ועיצוב דירה קטנה ומטריפה 7.webp";
import secondP1 from "../../images/שיפוץ ועיצוב דירה בסגנון נורדי 1.webp";
import secondP2 from "../../images/שיפוץ ועיצוב דירה בסגנון נורדי 3.webp";
import secondP3 from "../../images/שיפוץ ועיצוב דירה בסגנון נורדי 4.webp";
import secondP4 from "../../images/שיפוץ ועיצוב דירה בסגנון נורדי 5.webp";
import secondP5 from "../../images/שיפוץ ועיצוב דירה בסגנון נורדי 6.webp";
import thirdP1 from "../../images/שיפוץ ועיצוב פנטהאוז מודרני יוקרתי 1.webp";
import thirdP2 from "../../images/שיפוץ ועיצוב פנטהאוז מודרני יוקרתי 2.webp";
import thirdP3 from "../../images/שיפוץ ועיצוב פנטהאוז מודרני יוקרתי 3.webp";
import thirdP4 from "../../images/שיפוץ ועיצוב פנטהאוז מודרני יוקרתי 4.webp";
import thirdP5 from "../../images/שיפוץ ועיצוב פנטהאוז מודרני יוקרתי 5.webp";
import thirdP6 from "../../images/שיפוץ ועיצוב פנטהאוז מודרני יוקרתי 6.webp";
import thirdP7 from "../../images/שיפוץ ועיצוב פנטהאוז מודרני יוקרתי 7.webp";
import fourthP1 from "../../images/בסגנון בוהו AIRBNB עיצוב דירת 1.webp";
import fourthP2 from "../../images/בסגנון בוהו AIRBNB עיצוב דירת 2.webp";
import fourthP3 from "../../images/בסגנון בוהו AIRBNB עיצוב דירת 3.webp";
import fourthP4 from "../../images/בסגנון בוהו AIRBNB עיצוב דירת 4.webp";
import fourthP5 from "../../images/בסגנון בוהו AIRBNB עיצוב דירת 5.webp";
import fourthP6 from "../../images/בסגנון בוהו AIRBNB עיצוב דירת 6.webp";
import fourthP7 from "../../images/בסגנון בוהו AIRBNB עיצוב דירת 7.webp";
import fourthP8 from "../../images/בסגנון בוהו AIRBNB עיצוב דירת 8.webp";
import fifthP1 from "../../images/עיצוב דירה בסגנון סקנדינבי מודרני 1.webp";
import fifthP2 from "../../images/עיצוב דירה בסגנון סקנדינבי מודרני 2.webp";
import fifthP3 from "../../images/עיצוב דירה בסגנון סקנדינבי מודרני 3.webp";
import fifthP4 from "../../images/עיצוב דירה בסגנון סקנדינבי מודרני 4.webp";
import fifthP5 from "../../images/עיצוב דירה בסגנון סקנדינבי מודרני 5.webp";
import sixthP1 from "../../images/שיפוץ ועיצוב דירה בסגנון סקנדינבי מודרני 1.webp";
import sixthP2 from "../../images/שיפוץ ועיצוב דירה בסגנון סקנדינבי מודרני 2.webp";
import sixthP3 from "../../images/שיפוץ ועיצוב דירה בסגנון סקנדינבי מודרני 3.webp";
import sixthP4 from "../../images/שיפוץ ועיצוב דירה בסגנון סקנדינבי מודרני 4.webp";
import sixthP5 from "../../images/שיפוץ ועיצוב דירה בסגנון סקנדינבי מודרני 5.webp";
import sixthP6 from "../../images/שיפוץ ועיצוב דירה בסגנון סקנדינבי מודרני 6.webp";

const Button = ({ text, onClick }) => {
  return (
    <button className={styles.ctaButton} onClick={onClick}>
      {text}
    </button>
  );
};

const Projects = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState({});

  // פונקציה לשליחת הודעה בווצאפ
  const sendWhatsAppMessage = (projectName) => {
  const phoneNumber = '972544493213';
  const message = 'היי טלי הגעתי מהדף שלך, אשמח לשמוע עוד על...';
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  
  window.open(whatsappUrl, '_blank');
  };

  // נתונים לדוגמה - החלף בנתונים האמיתיים שלך
  const projects = [
    {
      id: 1,
      name: 'שיפוץ ועיצוב דירה קטנה ומטריפה',
      description: 'את הדירה הזאת קיבלתי עם קירות סגולים, שטיחים מקיר לקיר בצבע חום וריהוט חום אגוז כבד. אמיתי לגמרי!!! הלקוחות קנו את הדירה הזאת להשקעה מזוג מבוגר שחיו בה עם קירות בצבע סגול - כמובן שהכללל הוחלף והדירה עברה שיפוץ מסיבי כללי שכלל: שבירת קירות, הוצאת הריצוף הישן, החלפת אינסטלציה, חשמל, תכנון מחדש של חלוקת הבית והתאורה, חדר רחצה חדש, מטבח חדש וארונות בגדים חדשים בביצוע נגר בהתאם לעיצוב שתכננו יחד מראש. והתוצאה מטורפת!!!! בין אם אתם בונים בית, משפצים דירה או אפילו רק משדרגים חדר אחד בבית, אתם מוזמנים לדבר איתי. יחד נעצב לכם מקום יפה יותר לחיות בו.',
      orientation: 'landscape',
      mainImage: firstP1,
      thumbnails: [
        firstP2,
        firstP3,
        firstP4,
        firstP5,
        firstP6,
        firstP7,
      ]
    },
    {
      id: 2,
      name: 'שיפוץ ועיצוב דירה נורדית',
      description: 'אחד הפרויקטים האהובים עליי!! דירת סבתא משנות ה-60 בלימסול קפריסין של לקוח סופר מיוחד שרכש אותה להשקעה. הדירה הייתה במצב רעועה למדי, ומלאה באתגרים לפתור. ע"י תכנון מוקפד, הקשבה לרצונותיו והרבה מחשבה, הדירה הסופר ישנה בת 2 החדרים הפכה לדירת 3 חדרים נורדית חדשה ויפיפייה. מהפך של ממש! הדירה עברה שיפוץ מסיבי מלא כולל החלפת תשתיות אינסטלציה, חשמל, שבירת קירות, פתיחת חלל הסלון למטבח עם תוספת של חציצת סרגלי עץ מודרנית, דלתות חדשות, חלונות, חדר רחצה, פרטי נגרות, ועוד. דירות קטנות מביאות איתן המון אתגרים בעיצוב מחדש, העמדת הרהיטים, הוספת מקומות אחסון ויצירת מטבח מרווח שכיף לבשל בו. וכשיש מקום מוגבל, כל פרט חשוב - מהבחירה ברהיטים ועד צבע הקירות. אם אתם מחפשים עזרה מקצועית בעיצוב דירה קטנה, אני כאן בשבילכם! צרו קשר ונגלה יחד את הפוטנציאל של החלל שלכם.',
      orientation: 'portrait',
      mainImage: secondP1,
      thumbnails: [
        secondP2,
        secondP3,
        secondP4,
        secondP5,
      ]
    },
    {
      id: 3,
      name: 'שיפוץ ועיצוב פנטהאוז מודרני יוקרתי',
      description: 'דירת פנטהאוז שעברה שיפוץ מקיף - כל קירות הדירה גולחו והריצוף הישן הוסר. למעשה כל פנים הבית נהרס ונבנה מחדש בסגנון מודרני ייחודי, קווים נקיים ונעימים. הוחלפו כל תשתיות האינסטלציה, חשמל, תאורה, מיזוג אוויר, חלונות ודלתות. בתכנון, ניצלנו את המרפסת שסובבת את כל הדירה לכניסת אור טבעי מכל חלל, כך שלכל חדר שינה תהיה יציאה למרפסת פרטית. המטבח שהיה בחלל סגור הורחב עם אי מרשים באורך 4.5 מטרים עם משטח עבודה רחב ואזור ישיבה פונה לכיוון הסלון ופינת האוכל. אחרי תהליך ארוך והרבה מחשבה מאוהבת בתוצאה ולא פחות מהדרך.',
      orientation: 'landscape',
      mainImage: thirdP1,
      thumbnails: [
        thirdP2,
        thirdP3,
        thirdP4,
        thirdP5,
        thirdP6,
        thirdP7,
      ]
    },
    {
      id: 4,
      name: 'עיצוב דירת AIRBNB בסגנון בוהו',
      description: 'את הדירה הזאת עיצבתי בשלט רחוק - אני גרתי בקפריסין והלקוחות מישראל. הם קנו דירה להשקעה בקפריסין שיוכלו גם להשכיר וגם להגיע אליה להתפנק כמה פעמים בשנה. היה להם חלום ברור איך הם רוצים שהיא תראה, בסגנון בוהו האהוב עליי - צבעונית, שמחה ומיוחדת. שתתאים לשהייה גם לזוג וגם למשפחה. הכנתי לוח השראה, שכלל ריהוט פונקציונלי (ספה נפתחת למיטה זוגית, שולחן נפתח וכו\' ...) פרטי דקורציה, אריחים חדשים לשדרוג המטבח וצבעים לקירות. דייקנו עוד את הרצונות והחלומות ומיד התחלתי בתהליך עם בעלי המקצוע. אחת לכמה ימים קיבלו ממני עדכונים ותמונות על ההתקדמות בעבודה ולאחר חודש בלבד התהליך הושלם. הם הגיעו מישראל לראות את התוצאה ולשהות בדירה החדשה שחלמו עליה והתאהבו. פתחנו בקבוק יין מהיקב הפרטי שלהם וסיכמנו תהליך מהנה עם תוצאה מושלמת. צריכים גם עזרה בשדרוג הבית ולא יודעים מאיפה מתחילים? מוזמנים לשיחה ייעוץ ראשונית ויחד נתחיל בתהליך.',
      orientation: 'portrait',
      mainImage: fourthP1,
      thumbnails: [
        fourthP2,
        fourthP3,
        fourthP4,
        fourthP5,
        fourthP6,
        fourthP7,
        fourthP8,
      ]
    },
    {
      id: 5,
      name: 'עיצוב דירה בסגנון סקנדינבי מודרני',
      description: 'דירת 3 חדרים שעברה ריענון, שדרוג המטבח והום סטיילינג כללי. כל ריהוט הבית הוחלף לריהוט חדש ומודרני, דלתות המטבח נשלחו לצביעה מחדש, הקרמיקה ומשטח העבודה במטבח הוחלפו, כל הבית נצבע. ולמעשה מראה הבית כולו השתנה לחלוטין בזמן קצר, ללא שבירת קירות ובעלות נמוכה.',
      orientation: 'landscape',
      mainImage: fifthP1,
      thumbnails: [
        fifthP2,
        fifthP3,
        fifthP4,
        fifthP5,
      ]
    },
    {
      id: 6,
      name: 'שיפוץ ועיצוב דירה בסגנון סקנדינבי מודרני',
      description: 'דירת 2 חדרים ישנה שעברה שיפוץ מקיף. השיפוץ כלל החלפת צנרת וריצוף, חדר רחצה חדש לגמרי, מטבח חדש בביצוע נגר ולסיום סיומת עיצוב פנים והום סטיילינג בסגנון סקנדינבי מודרני וייחודי. והתוצאה בית חמים ומעוצב לזוג צעיר.',
      orientation: 'portrait',
      mainImage: sixthP1,
      thumbnails: [
        sixthP2,
        sixthP3,
        sixthP4,
        sixthP5,
        sixthP6,
      ]
    }
  ];

  const navigateImage = (projectId, direction, totalImages) => {
    const currentIndex = currentImageIndex[projectId] || 0;
    let newIndex;
    
    if (direction === 'next') {
      newIndex = currentIndex === totalImages ? 0 : currentIndex + 1;
    } else {
      newIndex = currentIndex === 0 ? totalImages : currentIndex - 1;
    }
    
    setCurrentImageIndex({
      ...currentImageIndex,
      [projectId]: newIndex
    });
  };

  const scrollThumbnails = (projectId, direction) => {
    const container = document.getElementById(`thumbnails-${projectId}`);
    if (container) {
      const scrollAmount = 200;
      container.scrollBy({
        left: direction === 'right' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className={styles.projectsContainer} id="פרוייקטים">
      <div className={styles.header}>
        <h1 className={styles.mainTitle}>הפרויקטים שלי</h1>
        <p className={styles.subtitle}>ריכזתי עבורכם את הפרוייקטים הנבחרים שלי, כל פרויקט הוא סיפור ייחודי של עיצוב ויצירה מותאמת אישית. <br/> מוזמנים לגלול בין הפרוייקטים </p>
      </div>

      <div className={styles.projectsList}>
        {projects.map((project) => {
          const currentIndex = currentImageIndex[project.id] || 0;
          const displayImage = currentIndex === 0 
            ? project.mainImage 
            : project.thumbnails[currentIndex - 1];
          const totalImages = project.thumbnails.length;

          return (
            <div key={project.id} className={styles.projectCard}>
              <div className={styles.glassCard}>
                <div className={styles.projectHeader}>
                  <h2 className={styles.projectName}>{project.name}</h2>
                </div>

                <p className={styles.projectDescription}>{project.description}</p>

                <div className={styles.mainImageSection}>
                  <button 
                    className={`${styles.imageNavButton} ${styles.imageNavButtonRight}`}
                    onClick={() => navigateImage(project.id, 'prev', totalImages)}
                    aria-label="תמונה קודמת"
                  >
                    ‹
                  </button>

                  <div className={`${styles.mainImageContainer} ${styles[project.orientation]}`}>
                    <img
                      src={displayImage}
                      alt={project.name}
                      className={styles.mainImage}
                      loading="lazy"
                    />
                    <div className={styles.imageOverlay}></div>
                  </div>

                  <button 
                    className={`${styles.imageNavButton} ${styles.imageNavButtonLeft}`}
                    onClick={() => navigateImage(project.id, 'next', totalImages)}
                    aria-label="תמונה הבאה"
                  >
                    ›
                  </button>
                </div>

                <div className={styles.imageIndicators}>
                  {[project.mainImage, ...project.thumbnails].map((_, index) => (
                    <div 
                      key={index}
                      className={`${styles.indicator} ${currentIndex === index ? styles.indicatorActive : ''}`}
                    />
                  ))}
                </div>

                <div className={styles.thumbnailsSection}>
                  <button 
                    className={`${styles.scrollButton} ${styles.scrollButtonRight}`}
                    onClick={() => scrollThumbnails(project.id, 'left')}
                    aria-label="גלול ימינה"
                  >
                    ›
                  </button>

                  <div 
                    className={styles.thumbnailsContainer}
                    id={`thumbnails-${project.id}`}
                  >
                    <div className={styles.thumbnailsGrid}>
                      <div 
                        className={`${styles.thumbnailItem} ${currentIndex === 0 ? styles.thumbnailItemActive : ''}`}
                        onClick={() => setCurrentImageIndex({...currentImageIndex, [project.id]: 0})}
                      >
                        <img src={project.mainImage} alt="תמונה ראשית" loading="lazy" />
                        <div className={styles.thumbnailOverlay}></div>
                      </div>
                      
                      {project.thumbnails.map((thumb, index) => (
                        <div 
                          key={index}
                          className={`${styles.thumbnailItem} ${currentIndex === index + 1 ? styles.thumbnailItemActive : ''}`}
                          onClick={() => setCurrentImageIndex({...currentImageIndex, [project.id]: index + 1})}
                        >
                          <img src={thumb} alt={`${project.name} - ${index + 1}`} loading="lazy" />
                          <div className={styles.thumbnailOverlay}></div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <button 
                    className={`${styles.scrollButton} ${styles.scrollButtonLeft}`}
                    onClick={() => scrollThumbnails(project.id, 'right')}
                    aria-label="גלול שמאלה"
                  >
                    ‹
                  </button>
                </div>

                <div className={styles.buttonContainer}>
                  <Button 
                    text="טלי, בואי נדבר!" 
                    onClick={() => sendWhatsAppMessage(project.name)}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.ctaSection}>
        <div className={styles.ctaGlassCard}>
          <p className={styles.ctaMainText}>
            פגישת ייעוץ לפני שיפוץ או בנייה? עיצוב פנים? הום סטיילינג? הלבשת הבית?
          </p>
          <p className={styles.ctaSubText}>
            אם אתם לא יודעים מה מכל אלו אתם צריכים?
          </p>
          <p className={styles.ctaHighlight}>
            שיחת טלפון היא הצעד הראשון לבית המושלם שלכם
          </p>
          <p className={styles.ctaInvite}>
            אני מזמינה אתכם לשיחת ייעוץ ראשונית ללא התחייבות
          </p>
          <Button 
            text="טלי, בואי נדבר!" 
            onClick={() => sendWhatsAppMessage('ייעוץ כללי')}
          />
        </div>
      </div>
    </div>
  );
};

export default Projects;